import { useMutation, useQuery, useInfiniteQuery } from 'react-query';
import axios from 'axios';
import { useStores } from '../state';
import URLAssembler from 'url-assembler';
import {
  ServerResponseType,
  Customer,
  APIendPoints,
  generalProp,
  Contract,
  User,
  BranchOfficesResponse,
  BranchOfficesResponseItem,
  VehiclesResp,
  Vehicle,
  IEmailsList,
  IDictionary,
  IDCheck,
  NotificationRes,
  NotificationListRes,
  Statsresponse,
  BrandsRes,
  DefaultCostRes,
  ExternalCaptureProcess,
} from './types';

import config from '../config';

const APIUrl = config.apiURL;

const buildUrl = (path: string, query: Record<string, unknown> = {}) =>
  URLAssembler(`${APIUrl}${path}`).query(query).toString();

const Query = () => {
  const { ui } = useStores();
  const localStorageToken = window.localStorage.getItem('token') || undefined;
  const parsedObje = localStorageToken
    ? JSON.parse(localStorageToken)
    : undefined;

  const token = ui.token ? ui.token : parsedObje;
  const apiClient = axios.create({
    baseURL: APIUrl,
    headers: {
      Accept: 'application/json',
      Authorization: token,
    },
  });

  const getIDcheckData = async (
    page: number,
    filter?: string,
    sortBy?: string,
    perPage?: number,
    context?: string,
    status?: [{ value: String }],
    approval_state?: [{ value: String }],
  ) => {
    const url = buildUrl('/id_checks', {
      page,
      q: filter,
      sort_by: sortBy,
      sort_direction: 'desc',
      per_page: perPage || '15',
      context: context || 'all',
      status,
      approval_state,
    });

    const { data } = await apiClient.get<ServerResponseType>(url);

    return data;
  };
  const getBranchOfficesData = async (
    page: number,
    filter?: string,
    sortBy?: string,
  ) => {
    const url = buildUrl('/dealer/branch_offices', {
      page,
      q: filter,
      sort_by: sortBy,
      sort_direction: 'asc',
      per_page: '7',
    });

    const { data } = await apiClient.get<BranchOfficesResponse>(url);

    return data;
  };
  const getCSVfile = async () =>
    await apiClient.get(`${APIUrl}/vehicles/to_csv_file`);
  const getVehicles = async (
    page: number,
    filter?: string,
    sortBy?: string,
    per_page?: number,
  ) => {
    const url = buildUrl('/vehicles', {
      page,
      q: filter,
      sort_by: sortBy,
      sort_direction: 'asc',
      per_page: per_page || '50',
    });

    const { data } = await apiClient.get<VehiclesResp>(url);

    return data;
  };

  const getUsers = async (page: number, filter?: string, sortBy?: string) => {
    const url = buildUrl('/users', {
      page,
      q: filter,
      sort_by: sortBy,
      sort_direction: 'asc',
      per_page: '7',
    });

    const { data } = await apiClient.get<User[]>(url);

    return data;
  };
  const getCustomers = async (
    page: number,
    filter?: string,
    sortBy?: string,
    per_page?: number,
  ) => {
    const url = buildUrl('/customers', {
      page,
      q: filter,
      sort_by: sortBy,
      sort_direction: 'asc',
      per_page: per_page || '7',
    });

    const { data } = await apiClient.get<Customer[]>(url);

    return data;
  };
  const getScanToMail = async (
    page: number,
    filter?: string,
    sortBy?: string,
    per_page?: number,
    context?: string,
  ) => {
    const url = buildUrl('/scan_to_mail/emails', {
      page,
      q: filter,
      sort_by: sortBy,
      sort_direction: 'asc',
      per_page: per_page || '15',
      context: context || 'all',
    });

    const { data } = await apiClient.get<IEmailsList>(url);

    return data;
  };

  const getPushMessagesList = async (
    page: number,
    filter?: string,
    sortBy?: string,
  ) => {
    const url = buildUrl('/push_messages', {
      page,
      q: filter,
      sort_by: sortBy,
      sort_direction: 'asc',
      per_page: '50',
    });

    const { data } = await apiClient.get<NotificationListRes>(url);

    return data;
  };
  const getDashboardStatistics = async (id: number) => {
    const { data } = await apiClient.get<Statsresponse>(
      `${APIUrl}/dealer/headquarters/${id}/stats`,
    );

    return data;
  };
  const getVehiclesById = async (id: number) => {
    const { data } = await apiClient.get<Vehicle>(`${APIUrl}/vehicles/${id}`);

    return data;
  };
  const getVehiclesReservations = async (id: number) => {
    const { data } = await apiClient.get<Vehicle>(
      `${APIUrl}/reservations?vehicle_id=${id}`,
    );

    return data;
  };

  const getCustomerById = async (id: number) => {
    const { data } = await apiClient.get<Customer>(`${APIUrl}/customers/${id}`);

    return data;
  };
  const getIDCheckDataById = async (id: number) => {
    const { data } = await apiClient.get<IDCheck>(`${APIUrl}/id_checks/${id}`);

    return data;
  };
  const getBranchOfficeByID = async (id: number) => {
    const { data } = await apiClient.get<BranchOfficesResponseItem>(
      `${APIUrl}/dealer/branch_offices/${id}`,
    );

    return data;
  };
  const getHeadquarteByID = async (id: number) => {
    const { data } = await apiClient.get<BranchOfficesResponseItem>(
      `${APIUrl}/dealer/headquarters/${id}`,
    );

    return data;
  };
  const getContractById = async (url: string) => {
    const { data } = await apiClient.get<Contract>(url);

    return data;
  };
  const getContractEmailById = async (url: string) => {
    const { data } = await apiClient.get<any>(url);

    return data;
  };
  const getNewContractData = async (url: string) => {
    const { data } = await apiClient.get<Contract>(`${APIUrl}/${url}`);

    return data;
  };
  const getUserByID = async (id: number) => {
    const { data } = await apiClient.get<User>(`${APIUrl}/users/${id}`);

    return data;
  };
  const getDictionary = async () => {
    const { data } = await apiClient.get<IDictionary>(`${APIUrl}/dictionary`);

    return data;
  };

  const getNotificationCount = async () => {
    const { data } = await apiClient.get<NotificationRes>(
      `${APIUrl}/id_checks/context_counts`,
    );

    return data;
  };

  //@ts-ignore
  const QueryRequest = (
    { key, page, enabled = true, retry = 1 }: any,
    fetcher: () => Promise<any>,
  ) =>
    useQuery<any, Error>([key, page], fetcher, {
      keepPreviousData: !!page,
      enabled,
      retry,
    });

  const InfinitQueryRequest = (
    { key }: any,
    fetcher: (par: any) => Promise<any>,
  ) =>
    useInfiniteQuery<any, Error>([key], fetcher, {
      getPreviousPageParam: ({ pagination }) =>
        pagination.total_pages - Number(pagination.page),
      getNextPageParam: ({ pagination }) =>
        pagination.total_pages > pagination.page
          ? Number(pagination.page) + 1
          : undefined,
    });
  const MutationRequest = (url: string) =>
    useMutation((postRequestData: any) => apiClient.post(url, postRequestData));

  const MutationRequestPut = (url: string) =>
    useMutation((postRequestData: any) => apiClient.put(url, postRequestData));

  const MutationRequestDelete = (url: string) =>
    useMutation((postRequestData: any) =>
      apiClient.delete(url, postRequestData),
    );

  const DeleteIdScan = () => useMutation((id: string) => apiClient.delete(id));
  const DeleteAvatar = () => useMutation((id: string) => apiClient.delete(id));
  const DeleteVehiclesorReservation = () =>
    useMutation((id: string) => apiClient.delete(id));
  const MutationRequestPatch = (url: string) =>
    useMutation((postRequestData: any) =>
      apiClient.patch(url, postRequestData),
    );
  const SubmitDataToserver = ({ url }: { url: string }) => {
    return MutationRequest(url);
  };
  const ReturnVehiclesR = ({ url }: { url: string }) => {
    return MutationRequestPatch(url);
  };

  const creatLegitimation = async ({ id }: { id: number }) => {
    try {
      await apiClient.post(`/id_checks/${id}/approve`);
    } catch (e) {
      console.error('Failed to approve id check', id, e);
    }
  };

  const disCardLegitimation = async ({ id }: { id: number }) => {
    await apiClient.post(`/id_checks/${id}/discard`);
  };

  const submit2FacCode = async ({ code }: { code: number }) => {
    return apiClient.post(
      `/users/two_factor_auth_challenge_attempt?code=${code}`,
    );
  };
  const Loggin = ({ type }: generalProp) => {
    return MutationRequest(APIendPoints[type]);
  };

  const Logout = ({ type }: generalProp) =>
    MutationRequestDelete(APIendPoints[type]);

  const UpdateUserAvatar = ({ url }: { url: string }) => MutationRequest(url);
  const UpdateUserData = ({ url }: { url: string }) => MutationRequestPut(url);
  const FetchIDtableDate = ({
    key,
    page,
    searchQuery,
    sortBy,
    perPage,
    context,
    status,
    approval_state,
    enabled = true,
  }: any) =>
    QueryRequest({ key, page, enabled }, () =>
      getIDcheckData(
        page,
        searchQuery,
        sortBy,
        perPage,
        context,
        status,
        approval_state,
      ),
    );
  const FetchDictionarysData = ({ key, page }: any) =>
    QueryRequest({ key, page }, () => getDictionary());
  const FetchBranchOfficesData = ({ key, page, searchQuery, sortBy }: any) =>
    QueryRequest({ key, page }, () =>
      getBranchOfficesData(page, searchQuery, sortBy),
    );
  const FetchVehicles = ({ key, page, searchQuery, sortBy, perPage }: any) =>
    QueryRequest({ key, page }, () =>
      getVehicles(page, searchQuery, sortBy, perPage),
    );
  const FetchDashboardStatistics = ({ key, id }: any) =>
    QueryRequest({ key }, () => getDashboardStatistics(id));
  const FetchVehiclesById = ({ key, id, enabled }: any) =>
    QueryRequest({ key, enabled }, () => getVehiclesById(id));
  const FetchReservationsByVehiclesId = ({ key, id }: any) =>
    QueryRequest({ key }, () => getVehiclesReservations(id));

  const FetchUsersData = ({ key, page, searchQuery, sortBy }: any) =>
    QueryRequest({ key, page }, () => getUsers(page, searchQuery, sortBy));
  const FetchContractDefaultCosts = ({ key }: any) =>
    QueryRequest({ key }, async () => {
      const { data } = await apiClient.get<DefaultCostRes[]>(
        `${APIUrl}/contracts/default_costs_sets`,
      );

      return data;
    });
  const FetchUScanToMainData = ({
    key,
    page,
    searchQuery,
    sortBy,
    per_page,
    context,
  }: any) =>
    QueryRequest({ key, page }, () =>
      getScanToMail(page, searchQuery, sortBy, per_page, context),
    );

  const FetchCustomerssData = ({
    key,
    page,
    searchQuery,
    sortBy,
    perPage,
  }: any) =>
    QueryRequest({ key, page }, () =>
      getCustomers(page, searchQuery, sortBy, perPage),
    );
  const FetchVehiclesBrands = ({
    page,
    searchQuery,
    sortBy,
    perPage,
  }: any) => async () => {
    const url = buildUrl('/vehicle_brands', {
      page,
      q: searchQuery,
      sort_by: sortBy,
      sort_direction: 'asc',
      per_page: perPage || '30',
    });

    const { data } = await apiClient.get<BrandsRes[]>(url);

    return data;
  };

  const FetchCarsContractDateRange = ({
    id,
    start_date,
    end_date,
  }: any) => async () => {
    const url = buildUrl(`/vehicles/${id}/reservations_for_date_range`, {
      start_date,
      end_date,
    });

    const { data } = await apiClient.get<any>(url);

    return data;
  };

  const FetchSbContractValue = ({
    enabled,
    url,
    key = 'sb_contract',
  }: any) =>
    QueryRequest({ key, enabled }, async () => {
      const { data } = await apiClient.get<any>(url);

      return data;
    });
  const FetchPushMessagesList = ({ key, page, searchQuery, sortBy }: any) =>
    QueryRequest({ key, page }, () =>
      getPushMessagesList(page, searchQuery, sortBy),
    );
  const FetchPushMessagesListInfinit = ({ key }: any) =>
    InfinitQueryRequest({ key }, async ({ pageParam = 1 }) => {
      const url = buildUrl('/push_messages', {
        page: pageParam,
        per_page: '12',
        sort_direction: 'desc',
      });
      const { data } = await apiClient.get<NotificationListRes>(url);
      return data;
    });
  const FetchBranchOfficeDataById = ({ key, id, enabled = true }: any) =>
    QueryRequest({ key, enabled }, () => getBranchOfficeByID(id));
  const FetchHeadquarterDataById = ({ key, id, enabled = true }: any) =>
    QueryRequest({ key, enabled }, () => getHeadquarteByID(id));
  const FetchCustomerDataById = ({ key, id }: any) =>
    QueryRequest({ key }, () => getCustomerById(id));
  const FetchIDCheckDataById = ({ key, id, enabled = true }: any) =>
    QueryRequest({ key, enabled }, () => getIDCheckDataById(id));
  const FetchUserDataById = ({ key, id, enabled = true }: any) =>
    QueryRequest({ key, enabled }, () => getUserByID(id));
  const FetchNewContractData = ({ key, url }: any) =>
    QueryRequest({ key }, () => getNewContractData(url));
  const FetchContractDataById = ({ key, url, enabled }: any) =>
    QueryRequest({ key, enabled }, () => getContractById(url));
  const FetchContractSendViaEmailList = ({ key, url, enabled }: any) =>
    QueryRequest({ key, enabled }, () => getContractEmailById(url));
  const FetchLegtimationCount = ({ key }: any) =>
    QueryRequest({ key }, () => getNotificationCount());
  const FetchExternalImageCaptureProcess = ({
    key,
    token,
    enabled = false,
  }: any) =>
    QueryRequest({ key, enabled }, async () => {
      const { data } = await apiClient.get<ExternalCaptureProcess[]>(
        `${APIUrl}/external_image_capturing_processes/${token}`,
      );

      return data;
    });

  const ImportCarsFromSellerCsv = ({ key, enabled = false }: any) =>
    QueryRequest({ key, enabled }, async () => {
      const response = await apiClient.get<any>(
        `${APIUrl}/vehicles/import_from_eautoseller_csv`,
      );
      return response.status;
    });
  const getContractCSVfile = async (url: string) =>
    await apiClient.get(`${APIUrl}/${url}`);

  return {
    FetchSbContractValue,
    getContractCSVfile,
    ImportCarsFromSellerCsv,
    submit2FacCode,
    Loggin,
    Logout,
    FetchIDtableDate,
    FetchIDCheckDataById,
    QueryRequest,
    FetchCustomerDataById,
    FetchContractDataById,
    FetchContractSendViaEmailList,
    FetchUserDataById,
    UpdateUserAvatar,
    UpdateUserData,
    FetchUsersData,
    FetchBranchOfficesData,
    FetchBranchOfficeDataById,
    FetchHeadquarterDataById,
    FetchVehicles,
    FetchVehiclesById,
    FetchReservationsByVehiclesId,
    SubmitDataToserver,
    FetchUScanToMainData,
    FetchDictionarysData,
    creatLegitimation,
    getCustomers,
    FetchCustomerssData,
    ReturnVehiclesR,
    disCardLegitimation,
    FetchLegtimationCount,
    DeleteIdScan,
    DeleteAvatar,
    FetchPushMessagesList,
    FetchDashboardStatistics,
    getCSVfile,
    DeleteVehiclesorReservation,
    FetchNewContractData,
    FetchPushMessagesListInfinit,
    FetchVehiclesBrands,
    FetchContractDefaultCosts,
    FetchExternalImageCaptureProcess,
    FetchCarsContractDateRange,
  };
};
export default Query;
